import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2be1d35a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 查询 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_page_header = _resolveComponent("a-page-header")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, {
      type: "flex",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_page_header, {
          class: "demo-page-header",
          style: {"border":"1px solid rgb(235, 237, 240)","margin-bottom":"8px"},
          title: `订单统计(${_ctx.orderTotalList.length}/${_ctx.orderTotalList.length})`,
          "sub-title": "查询前台下单统计"
        }, {
          extra: _withCtx(() => []),
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions, {
              size: "small",
              column: 3
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "查询日期" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_date_picker, {
                      value: _ctx.orderTotalDateValue,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderTotalDateValue) = $event))
                    }, null, 8, ["value"]),
                    _createVNode(_component_a_button, {
                      style: {"margin-left":"6px"},
                      type: "primary",
                      onClick: _ctx.getOrderTotalList
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_a_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, {
                      title: "总统计",
                      style: {"margin-bottom":"20px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, "订单数量：" + _toDisplayString(_ctx.orderTotalTotal.TotalNum), 1),
                        _createElementVNode("p", null, "成品数量：" + _toDisplayString(_ctx.orderTotalTotal.TotalQty), 1),
                        _createElementVNode("p", null, "合计面积：" + _toDisplayString(_ctx.orderTotalTotal.TotalArea), 1),
                        _createElementVNode("p", null, "合计面积(折5厘)：" + _toDisplayString(_ctx.orderTotalTotal.TotalConvertArea), 1),
                        _createElementVNode("p", null, "合计金额：" + _toDisplayString(_ctx.orderTotalTotal.TotalAmt), 1),
                        _createElementVNode("p", null, "合计预付定金：" + _toDisplayString(_ctx.orderTotalTotal.TotalPrePayAmt), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 18 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              columns: _ctx.orderColumns,
              "row-key": (record) => record.ChsName,
              "data-source": _ctx.orderTotalList,
              loading: _ctx.orderTotalLoading,
              pagination: false,
              size: "small"
            }, null, 8, ["columns", "row-key", "data-source", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}